import React from 'react'
import { Container, Carousel } from '../../../components'

import { Link } from 'react-router-dom'
import { CardFeatured } from '.'
// import { viewportBreakpoint } from '../../../utils'
import data from '../../../database/events.json'

const Featured = ({embed}) => {
  return (
    <Container className="overflow-x-hidden">
      {/* Cards */}
      <div className="-mx-2 lg:-mx-4 text-gray-900 lg:mb-12 featured-carousel">
        <Carousel slidesToShow={1} slidesToScroll={1} >
          {
            data.map((d, index) => d.featured && (
              <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 lg:mb-4 h-full" key={index}>
                <Link to={`/event/detail/${d.id}`} className="h-full">
                  <CardFeatured data={d} featured={true} embed={embed}/>
                </Link>
              </div>
            ))
          }
        </Carousel>
      </div>
    </Container>
  )
}

export { Featured }
